import { render, staticRenderFns } from "./EasyDate.vue?vue&type=template&id=52b85811&"
import script from "./EasyDate.vue?vue&type=script&lang=js&"
export * from "./EasyDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports